"use strict";

exports.__esModule = true;
var _PlantTwinScreenWrapper = require("./PlantTwinScreenWrapper");
Object.keys(_PlantTwinScreenWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PlantTwinScreenWrapper[key]) return;
  exports[key] = _PlantTwinScreenWrapper[key];
});